import { render, staticRenderFns } from "./WhopperDashboard.vue?vue&type=template&id=59b2ab95&scoped=true"
import script from "./WhopperDashboard.vue?vue&type=script&lang=js"
export * from "./WhopperDashboard.vue?vue&type=script&lang=js"
import style0 from "./WhopperDashboard.vue?vue&type=style&index=0&id=59b2ab95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2ab95",
  null
  
)

export default component.exports